const themes = {
    light: {
        background: "#f8fafc",
        surface: "#ffffff",
        text: "#222222",
        textSecondary: "#555555",
        primary: "#1976d2",
        secondary: "#ff9800",
        error: "#d32f2f",
        border: "#e0e0e0",
        navbar: "#ffffff",
        navbarText: "#222222",
        card: "#ffffff",
        cardText: "#222222",
        button: "#1976d2",
        buttonText: "#ffffff",
        link: "#1976d2",
        linkHover: "#1565c0",
        // ...diğer renkler...
    },
    dark: {
        background: "#18181b",
        surface: "#222222",
        text: "#f3f4f6",
        textSecondary: "#bdbdbd",
        primary: "#90caf9",
        secondary: "#ffb74d",
        error: "#ef5350",
        border: "#333333",
        navbar: "#222222",
        navbarText: "#f3f4f6",
        card: "#23272f",
        cardText: "#f3f4f6",
        button: "#90caf9",
        buttonText: "#222222",
        link: "#90caf9",
        linkHover: "#64b5f6",
        // ...diğer renkler...
    }
};

let currentTheme = "light";
let customColors = {};

export function getColor(name) {
    return customColors[name] || themes[currentTheme][name];
}

export function setTheme(themeName) {
    if (themes[themeName]) {
        currentTheme = themeName;
    }
}

export function setCustomColor(name, value) {
    customColors[name] = value;
}

export function resetCustomColors() {
    customColors = {};
}

export function getCurrentTheme() {
    return currentTheme;
}
